import React from 'react';
import { CustomIcon } from '../CustomIcon/CustomIcon';
import './ModalCloseButton.scss';

export interface ModalCloseButtonProps {
  /** Accessible name describing what closes. */
  ariaLabel: string;
  /** Called when the close button is activated. */
  onClick: () => void;
  /** Color treatment for a light panel or dark overlay. */
  surface: 'light' | 'dark';
  /** Optional class used only for placement within the parent modal. */
  className?: string;
  /** Optional ref used for initial focus. */
  buttonRef?: React.Ref<HTMLButtonElement>;
}

/** Shared close control used by content and video modals. */
export const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
  ariaLabel,
  onClick,
  surface,
  className,
  buttonRef,
}) => (
  <button
    ref={buttonRef}
    type="button"
    className={`poly-modal-close poly-modal-close--${surface}${className ? ` ${className}` : ''}`}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    <CustomIcon name="close" size="var(--poly-size-modal-closeIcon)" aria-hidden="true" />
  </button>
);
